import { getClaimedContactIdCore } from '@gv/core';
import { supabase } from './supabase';

export async function getClaimedContactId(userId: string): Promise<string | null> {
    return getClaimedContactIdCore(supabase, userId);
}
